// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Container-module--bx--text-truncate--end--Pz+kf";
export var bxTextTruncateFront = "Container-module--bx--text-truncate--front--CoXS2";
export var overlay = "Container-module--overlay--0meR-";
export var visible = "Container-module--visible--9FlkN";